// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { HelpMenuComponent } from './components/help-menu/help-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TrendModule } from 'ngx-trend';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './containers/app.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarRightComponent } from './components/sidebar-right/sidebar-right.component';
import { TopMenuComponent } from './components/top-menu/top-menu.component';
import { throwIfAlreadyLoaded } from './guards/module-import.guard';
import { NotFoundComponent } from './components/not-found/not-found.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { SharedModule } from '@lfx/shared/shared.module';
import { HelpSupportFrameComponent } from './components/help-support-frame/help-support-frame.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { UnauthorizedComponent } from './containers/unauthorized/unauthorized.component';
import { NotSupportedViewComponent } from './containers/not-supported-view/not-supported-view.component';
import { ToastComponent } from './components/toast/toast.component';
import { NgHttpCachingModule } from 'ng-http-caching';
import { DatadogHttpErrorInterceptor } from './interceptors/datadog-http-error.interceptor';
import { DatadogGlobalErrorHandler } from './handlers/datadog-global-error.handler';

@NgModule({
  declarations: [
    AppComponent,
    UnauthorizedComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarRightComponent,
    TopMenuComponent,
    NotFoundComponent,
    HelpSupportFrameComponent,
    ForbiddenComponent,
    HelpMenuComponent,
    NotSupportedViewComponent,
    ToastComponent,
  ],
  exports: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarRightComponent,
    TopMenuComponent,
    UnauthorizedComponent,
    NotFoundComponent,
    ForbiddenComponent,
    NotSupportedViewComponent,
    ToastComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    BrowserAnimationsModule,
    NgbModule,
    TrendModule,
    NgHttpCachingModule,
    NgSelectModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    // Datadog HTTP error interceptor for automatic error tracking
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DatadogHttpErrorInterceptor,
      multi: true,
    },
    // Datadog global error handler for uncaught JS errors
    {
      provide: ErrorHandler,
      useClass: DatadogGlobalErrorHandler,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
